import api from "../../../services/api";

export const addUser = async (userData: { username: string; email: string; groups: string[] }) => {
  const { data } = await api.post("/api/cognito/admin/users", userData);
  return data;
};